<template>
  <div class="schedule-bar" :style="barStyle" />
</template>

<script lang="ts">
import { useScheduleBarStyle } from '@/src/hooks/useScheduleBarStyle'
import { useTemporalPlainTime } from '@/src/hooks/useTemporalPlainTime'

export default defineComponent({
  props: {
    colorHue: {
      type: Number,
      required: true,
    },
    from: {
      type: String,
      required: true,
    },
    to: {
      type: String,
      required: true,
    },
  },
  setup(props) {
    const from = useTemporalPlainTime(toRef(props, 'from'))
    const to = useTemporalPlainTime(toRef(props, 'to'))
    const baseStyle = useScheduleBarStyle({ from, to })

    const barStyle = computed(() => {
      return {
        left: baseStyle.value.left,
        width: baseStyle.value.width,
        backgroundColor: `hsl(${props.colorHue}, 60%, 85%)`,
      }
    })

    return { barStyle }
  },
})
</script>

<style scoped lang="scss">
.schedule-bar {
  border-radius: 4px;
  height: 4px;
  position: absolute;
}
</style>
